import React from "react";
import "./Cosection.css";
import sampleImage from '../Images/connect.png';
import { Link } from "react-router-dom";

const Cosection = () => {
  return (
    <div className="cosection-wrapper">
      <div className="cosection-container">
        {/* Image Card */}
        <div className="cosection-image-container">
          <div className="cosection-image-card">
            <img src={sampleImage} alt="Professional Tax Assistance" className="cosection-image" />
            <div className="cosection-image-overlay"></div>
          </div>
        </div>

        {/* Text Content */}
        <div className="cosection-content">
          <div className="cosection-text">
            <h2 className="cosection-heading">
              Ready to Transform Your <span className="cosection-highlight">Financial Journey</span>?
            </h2>
            <p className="cosection-subtext">
              Our dedicated team of tax experts is here to provide personalized guidance and comprehensive 
              solutions tailored to your unique financial situation. Whether you're navigating complex tax 
              regulations, planning for future growth, or seeking strategic financial advice, we're committed 
              to making every step of your financial journey seamless and successful.
            </p>
      
            <Link to="/contact">
              <button className="cosection-btn">
                <span>Schedule Your Free Consultation</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </Link>
          </div>
        </div>
        
        {/* Background Elements */}
        <div className="cosection-bg-element-1"></div>
        <div className="cosection-bg-element-2"></div>
      </div>
    </div>
  );
};

export default Cosection;